import React, {useEffect, useState} from 'react';
import {ethers} from 'ethers';
// import { v4 as uuidv4 } from 'uuid';
// import { useNavigate } from 'react-router-dom';
import { client } from '../client';

import { contractABI, contactAddress } from '../utils/constants';

export const TransactionContext = React.createContext();

const {ethereum} = window;

const getEthereumContract = () => {
    const provider = new ethers.providers.Web3Provider(ethereum);
    const signer = provider.getSigner();
    const transactionContract = new ethers.Contract(contactAddress,contractABI,signer);

    return transactionContract;
}

export const TransactionProvider = ({ children }) => {
    // const navigate = useNavigate();
    const [x, setX] = useState(false)
    const [currentAccount, setCurrentAccount] = useState('');
    const [formData, setFormData] = useState({ addressTo: '', amount: '', keyword: '', message: '' });
    const [isLoading, setIsLoading] = useState(false)
    const [transactionCount, setTransactionCount] = useState(localStorage.getItem('transactionCount'));

    const handleChange = (e, name) => {
        setFormData((prevState) => ({...prevState, [name]: e.target.value}));
    }
    
    

    const checkIfWalletIsConnected = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");

            const accounts = await ethereum.request({method: 'eth_accounts'});

            if(accounts.length) {
                setX(true)
                setCurrentAccount(accounts[0]);
            }else{
                setX(false)
                console.log('No accounts found');
            }
            
        } catch (error) {
            console.log(error);

            throw new Error("No ethereum object.")
        }

        

        
    }

    const connectWallet = async () => {
        try{
            if(!ethereum) return alert("Please install MetaMask");

            const accounts = await ethereum.request({method: 'eth_requestAccounts'})

            setCurrentAccount(accounts[0]);

            console.log(accounts[0])

            const query = `*[_type=="user" && userName == "${currentAccount}"]`
            client.fetch(query).then(res => {
                if(res.length){
                    client.create({
                        _type: 'user',
                        userName:currentAccount,
                        image: 'https://picsum.photos/200'
                    })
                    // navigate('/', { replace: true });
                    setX(true)
                } else {
                    // navigate('/', { replace: true });
                    setX(true)  
                }
            })
            
        } catch(err){
            console.log(err);

            throw new Error("No ethereum object.")
        }
    }

    const sendTransaction = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");
            const {addressTo, amount, keyword, message} = formData;
            const transactionContract = getEthereumContract();
            const parsedAmount = ethers.utils.parseEther(amount);

            await ethereum.request({
                method: 'eth_sendTransaction',
                params: [{
                    from: currentAccount,
                    to: addressTo,
                    gas: '0x5208',
                    value: parsedAmount._hex,
                }]
            })

            const transactionHash = await transactionContract.addtoBlockchain(addressTo, parsedAmount, message, keyword);

            setIsLoading(true);
            console.log(`Loading : ${transactionHash.hash}`);
            await transactionHash.wait();
            setIsLoading(false);
            console.log(`Success : ${transactionHash.hash}`);

            const transactionCount = await transactionContract.getTransactionCount();
            setTransactionCount(transactionCount.toNumber());

        } catch (error) {
            console.log(error);

            throw new Error("No ethereum object.")
        }
    }

    useEffect(() =>{
        checkIfWalletIsConnected();
    }, []);

    return (
        <TransactionContext.Provider value = {{connectWallet,x, currentAccount, formData, setFormData, handleChange, sendTransaction}}>
            {children}
        </TransactionContext.Provider>
    )
}